import RestService from './RestService';

export default class PreviewCertificate extends RestService {
    download(params) {
        return this.get('/download/certificate/preview', params);
    }
}
